import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import EssenceFiles from "../EssenceFiles";
import LibraryPdfView from "./LibraryPdfView";

export default class LibraryItem extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      files: [],
      singleFile: false,
    };
    this.link = document.createElement("a");
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let item = {};
    let files = [];
    let singleFile = false;

    if (this.props.id) {
      item = await this.context.api.q(`/${this.props.essence}/get`, {
        id: this.props.id,
      });
      files = await this.context.api.q("/object/file", {
        id: this.props.id,
      });

      let filesList = Array.isArray(files) ? files : [];

      if (filesList.length === 1) {
        let result = await this.context.api.q("/object/file/get", {
          id: this.props.id,
          file: filesList[0].file,
        });
        if (result !== false) {
          singleFile = result;
          singleFile.src = result.type + result.data;
          if (result.type === "data:application/pdf;base64,") {
            singleFile.isPdf = true;
          }
        } else {
          this.context.toast("Не удалось скачать файл", "error");
        }
      }

      this.setState({
        files: filesList,
      });
    }
    this.setState({ pending: false, item, singleFile });
  };
  download = async (file) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/object/file/get", {
      id: this.props.id,
      file,
    });
    if (result !== false) {
      let data = result.type + result.data;
      this.link.setAttribute("href", data);
      this.link.setAttribute("download", result.name);
      this.link.setAttribute("target", "_blank");
      this.link.click();
      this.setState({ pending: false });
    } else {
      this.context.toast("Не удалось скачать файл", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    const { item } = this.state;
    let itemFound = item.id ? true : false;
    let isPdf = false;

    if (this.state.singleFile) {
      if (this.state.singleFile.isPdf) {
        isPdf = true;
      }
    }

    const filesList = this.state.files.map((file) => {
      file.date = new Date(file.date);
      file.loaded = new Date(file.loaded);

      return (
        <div
          key={`${file.name}${file.loaded}`}
          onClick={() => this.download(file.file)}
          className="py-2 font-size-lg cursor-pointer text-hover-primary d-flex align-items-center"
        >
          <i className="fa fa-file-o fa-2x mr-4"></i>
          {file.description} {file.name}
        </div>
      );
    });

    let contentArea = null;
    let foldersArea = null;

    if (this.state.singleFile && this.state.singleFile.isPdf) {
      contentArea = (
        <LibraryPdfView
          downloadClick={() => this.download(this.state.singleFile.file)}
          base64={this.state.singleFile.src}
        />
      );
    } else {
      contentArea = filesList;
    }
    if (!this.state.singleFile.isPdf && !this.state.pending && item) {
      const allTreeItems = this.props.treeItems || {};
      let childrenTreeItems = [];
      Object.entries(allTreeItems).forEach(([id, item]) => {
        if (this.state.item.id === item.node) {
          childrenTreeItems.push(item);
        }
      });

      let treeLinks = childrenTreeItems.map((item) => {
        return this.state.item.id === item.node ? (
          <div className="my-2 col-lg-4 text-center" key={item.id}>
            <Link
              to={`/${this.props.essence}/${item.id}/`}
              className="text-muted text-hover-dark-50"
            >
              <div className="mb-4">
                <span className="fa fa-folder-o icon-3x  "></span>
              </div>

              {item.label}
            </Link>
          </div>
        ) : null;
      });
      foldersArea = childrenTreeItems.length ? (
        <div className="row mt-5">{treeLinks}</div>
      ) : null;
    }

    return (
      <>
        <div className="card card-custom card-stretch">
          <div className={`card-body ${isPdf ? "p-0" : "px-7 py-5"} `}>
            <Blocker on={this.state.pending}>
              {!itemFound && !this.state.pending && this.props.id ? (
                <DefaultNotFound />
              ) : null}
              {itemFound && !this.state.pending ? (
                <>
                  {isPdf ? null : (
                    <h3 className="mb-5 pb-3 border-bottom">{item.label}</h3>
                  )}
                  {foldersArea}
                  {foldersArea && contentArea ? (
                    <div className="mt-5 pt-5 border-top"></div>
                  ) : null}
                  {contentArea}
                </>
              ) : null}
            </Blocker>
          </div>
        </div>
      </>
    );
  }
}
